import { BlogPost } from '../blog';

import { StylePost } from './post';

export default function Post() {
  const image = StylePost();

  return <BlogPost {...image} />;
}
